var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconTuitionFees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "32. Clipboard",
    id: "_32._Clipboard"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,2H22a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2H7A3,3,0,0,0,4,5V29a3,3,0,0,0,3,3H25a3,3,0,0,0,3-3V5A3,3,0,0,0,25,2ZM12,2h8V3h0V4H12ZM26,29a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V5A1,1,0,0,1,7,4h3a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2h3a1,1,0,0,1,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,19a1,1,0,0,0,2,0v-.18A3,3,0,0,0,16,13a1,1,0,0,1,0-2h2a1,1,0,0,0,0-2H17a1,1,0,0,0-2,0v.18A3,3,0,0,0,16,15a1,1,0,0,1,0,2H14a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,22H9a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,22H15a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,26H9a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,26H15a1,1,0,0,0,0,2h8a1,1,0,0,0,0-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconTuitionFees);
export default __webpack_public_path__ + "static/media/common_icon_tuition_fees.162d3f19dfe0b27d6c4087ec5d9e1bc8.svg";
export { ForwardRef as ReactComponent };